import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchTenderBidders(ctx, queryParams) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/tender-bidders`, { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		addTenderBidders(ctx, { payload }) {
			return new Promise((resolve, reject) => {
				axios
					.post(`/tender-bidders`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		updateTenderBidder(ctx, { id, payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/tender-bidders/${id}`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		deleteTenderBidder(ctx, { id, queryParams }) {
			return new Promise((resolve, reject) => {
				axios
					.delete(`/tender-bidders/${id}`, { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		sendInvitation(ctx, { payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/tender-invitations/resend`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}